/* eslint-disable react/prop-types */
import './index.scss';
import './ModalCardUsers.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import { getMMDDYY } from '../../helpers/utils/date';
import { Loader } from '@piggytechng/component-library';

function ModalCardUsers({ modalIsOpen, setIsOpen, data, isLoading }: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }

  const users = data || [];

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <div className="modal-card-users">
        <div className="modal-card-users__header">
          <h2>Card Users</h2>
          <button onClick={closeModal}>&times;</button>
        </div>

        <div className="modal-card-users__body">
          {isLoading ? (
            <div className="modal-card-users__loader">
              <Loader color="#1734ca" />
            </div>
          ) : users.length > 0 ? (
            <ul className="modal-card-users__list">
              {users.map((user: any, index: number) => (
                <li key={user.userId || index} className="modal-card-users__item">
                  <div className="modal-card-users__item-main">
                    <p className="modal-card-users__name">
                      {[user.firstName, user.lastName].filter(Boolean).join(' ') || '-----'}
                    </p>
                    <p className="modal-card-users__email">{user.email || '-----'}</p>
                    {user.phone && <p className="modal-card-users__phone">{user.phone}</p>}
                  </div>
                  {user.cardAddDate ? (
                    <span className="modal-card-users__date">Added: {getMMDDYY(user.cardAddDate)}</span>
                  ) : null}
                </li>
              ))}
            </ul>
          ) : (
            <p className="modal-card-users__empty">No users are sharing this card.</p>
          )}
        </div>
      </div>
    </ModalBase>
  );
}

export default ModalCardUsers;
